import { useReinstallService } from './handlers/install'
import FormChatPro from './Form/FormChatPro'

export const CHAT_PRO = {
  key: 'chat_pro',
  onReinstall: useReinstallService,
  Form: FormChatPro,
  SCOPE: []
}

export default CHAT_PRO
